@if (group) {
    <header class="first-time-user-experience__header">
        <h1 class="first-time-user-experience__title">
            <span>{{group.get('label')}} ? {{'first_time_user_experience.nice' | translate}}</span>
            <br>
            <strong>{{'first_time_user_experience.what_to_do_first' | translate}}</strong>
        </h1>
        <div class="first-time-user-experience__decoration"
             aria-hidden="true">
        </div>
    </header>
    <div class="first-time-user-experience__content">
        <div class="first-time-user-experience__primary-content">
            <div class="first-time-user-experience__progress">
                <mat-progress-spinner class="first-time-user-experience__progress-spinner"
                                      mode="determinate"
                                      [value]="0">
                </mat-progress-spinner>
                <div class="first-time-user-experience__progress-percentage"
                     aria-hidden="true">
                    <span>0&nbsp;%</span>
                </div>
            </div>
            <div class="first-time-user-experience__lesson">
                <div class="first-time-user-experience__lesson-period">
                    <span>First steps</span>
                </div>
                <div class="first-time-user-experience__lesson-sequence">
                    <span>Hello everyone!</span>
                </div>
            </div>
            <button class="first-time-user-experience__start-button"
                    data-e2e="first-time-user-experience-open-progression"
                    (click)="onNext('open-progression')">
                <span>{{'first_time_user_experience.start_program' | translate}} {{group.get('label')}}</span>
                <mat-icon svgIcon="first-time-user-experience__play"></mat-icon>
            </button>
        </div>
        <button class="first-time-user-experience__search-button"
            data-e2e="first-time-user-experience-open-lessons-search"
            (click)="onNext('open-lessons-search')">
            <mat-icon class="first-time-user-experience__search-icon"
                      svgIcon="first-time-user-experience__search">
            </mat-icon>
            <div class="first-time-user-experience__search-label">
                <span>{{'first_time_user_experience.find_lesson' | translate}} {{group.get('label')}}</span>
            </div>
        </button>
    </div>
}
